'use client';

import { FC } from 'react';

import { Address } from '@ravago/shared/page-data/models/elements/address.model';
import { Badge } from '@ravago/shared/radiance/components/badge/components/Badge/Badge';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Radio } from '@ravago/shared/radiance/components/radio/components/Radio/Radio';
import { RadioGroup } from '@ravago/shared/radiance/components/radio/components/RadioGroup/RadioGroup';
import { MultiLineText } from '@ravago/shared/radiance/components/typography/components/MultiLineText/MultiLineText';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

interface Props {
   addresses: Address[];
   selectedAddressId: number;
   onSelect: (address: Address) => void;
}

export const DeliveryAddressSelector: FC<Props> = ({ addresses, selectedAddressId, onSelect }) => {
   const translate = useTranslations();

   return (
      <Box direction="column">
         <RadioGroup value={addresses.find((a) => a.id === selectedAddressId)} onChange={(address) => onSelect(address)}>
            <Box direction="column" gap="md">
               {addresses.map((address) => (
                  <Radio key={address.id} id={`checkout-delivery-address-${address.id}`} value={address}>
                     {address.isDefault && (
                        <Badge variant="info">
                           <Typography component="p" variant="small" color="inherit">
                              {translate('page-consumer.request-for-quotation.default')}
                           </Typography>
                        </Badge>
                     )}
                     <Typography variant="small">
                        <MultiLineText text={address.htmlFormat} lineBreak="<br>" />
                     </Typography>
                  </Radio>
               ))}
            </Box>
         </RadioGroup>
      </Box>
   );
};
